module.exports = __webpack_public_path__ + "img/47_15.9b2c1a89.png";